import type { SiteResponse } from '@on3/api';
import { useAuth } from '@on3/ui-lib/index';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';

import { FanSiteItem } from './FanSiteItem';
import { TeamMiniNav } from './TeamMiniNav';
import styles from './Teams.module.scss';

interface IFanSiteListProps {
  fanSites: SiteResponse[] | null;
  highSchools: SiteResponse[] | null;
}

export const Teams = ({ fanSites, highSchools }: IFanSiteListProps) => {
  const { user } = useAuth();
  const { routeQuery } = useDynamicRoute();
  const isHighSchool = routeQuery.type === 'highschool';
  const userSiteKeys = user?.si;
  const highSchoolSites = highSchools?.filter(
    (site) => site.live && site.inIndex,
  );
  const teamSites = fanSites?.filter((site) => site.live && site.inIndex);

  const selectedSites = isHighSchool ? highSchoolSites : teamSites;
  const sortedTeamSites = [...(selectedSites || [])].sort((a, b) => {
    // Check if either a or b key is present in userSiteKeys
    const aIsUserSite = userSiteKeys?.includes(a.key);
    const bIsUserSite = userSiteKeys?.includes(b.key);

    if (aIsUserSite && !bIsUserSite) {
      return -1; // Move a to the top
    }

    if (!aIsUserSite && bIsUserSite) {
      return 1; // Move b to the top
    }

    // If both or neither are user sites, perform alphabetical sorting
    const aTeam = a?.organization?.knownAs ?? a?.organization?.name ?? 'z';
    const bTeam = b?.organization?.knownAs ?? b?.organization?.name ?? 'z';

    if (aTeam && bTeam) {
      return aTeam.localeCompare(bTeam);
    }

    return 0;
  });

  return (
    <section>
      <TeamMiniNav />
      <ul className={styles.list}>
        {sortedTeamSites.map((site: SiteResponse) => {
          const isFavoriteTeam = userSiteKeys?.includes(site.key);

          return (
            <FanSiteItem
              data={site}
              isFavoriteTeam={isFavoriteTeam}
              key={site.key}
            />
          );
        })}
      </ul>
    </section>
  );
};
